"use client";

import { useState } from "react";
import Link from "next/link";
import { MenuOutlined, CloseOutlined, RocketOutlined } from "@ant-design/icons";
import FaImage from "../../image/FaImage";
import Image from "next/image";
import { IoSunnyOutline } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import Cookies from "js-cookie";
import AuthDrawer from "../../drawer/AuthDrawer/AuthDrawer";
import { useDispatch, useSelector } from "react-redux";
import { F_TOKEN_STORE_KEY } from "@/constants/storage";
import { useRouter } from "next/navigation";
import { setUser } from "@/redux/slices/userSlice";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import CommonImage from "../../image/CommonImage";
import NotificationMenu from "./StudentNotifications";
import StudentNotifications from "./StudentNotifications";
import StudentTopNav from "./StudentTopNav";
import { usePathname } from "next/navigation";
import ThemeToggle from "../../darkMode/ThemeToggle";
import debounce from "lodash.debounce";
import StudentAuthHeader from "./StudentAuthHeader";
import MobileMenuDrawer from "./components/drawer/MobileMenuDrawer";
import SearchBarDesktop from "./components/search/SearchBarDesktop";
import AuthMenuDrawer from "./components/drawer/AuthMenuDrawer";

export default function Header() {
  const menuItems = [
    {
      key: "home",
      label: "হোম",
      href: "/",
      icon: "/images/admission-icon/computer.avif",
    },
    {
      key: "courses",
      label: "কোর্স",
      href: "/courses/all",
      icon: "/images/admission-icon/computer.avif",
    },
    {
      key: "freeExam",
      label: "ফ্রি এক্সাম",
      href: "/student/free-exam",
      icon: "/images/admission-icon/computer.avif",
    },
    {
      key: "branches",
      label: "শাখাসমূহ",
      href: "/branches",
      icon: "/images/admission-icon/computer.avif",
    },
  ];

  const pathname = usePathname();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotifyOpen, setIsNotifyOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const router = useRouter();

  const logoutHandler = () => {
    Cookies.remove(F_TOKEN_STORE_KEY);
    dispatch(setUser(null));
    router.push("/login");
  };

  const userInfo = useSelector((state) => state.user.userInfo);
  const setting = useSelector((state) => state.setting.data);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
    setIsNotifyOpen(false);
    setIsMenuOpen(false);
  };

  const toggleNotifyMenu = () => {
    setIsNotifyOpen((prev) => !prev);
    setIsDropdownOpen(false);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIsDropdownOpen(false);
    setIsNotifyOpen(false);
  };

  const [openMenu, setOpenMenu] = useState(null);

  const handleToggleProfile = () => {
    setOpenMenu((prev) => (prev === "profile" ? null : "profile"));
  };

  const handleToggleNotification = () => {
    setOpenMenu((prev) => (prev === "notification" ? null : "notification"));
  };

  return (
    <header className={`header ${pathname === "/" ? "header-bg" : ""}`}>
      <div className="header-container">
        <div className="flex items-center justify-between py-2 sm:py-3 md:py-[15px]">
          {/* Logo */}
          <Link
            href="/"
            className="flex items-center text-xl font-bold text-[#2e4e8d]"
          >
            <FaImage
              src={
                // setting?.logo_light_url ??
                "/images/header-footer/main_logo_light.avif"
              }
              alt={"Mail Logo"}
              className="max-w-[165px] h-[48px]"
              classes="[.dark_&]:hidden inline-block"
            />
            <FaImage
              src={
                // setting?.logo_dark_url ??
                "/images/header-footer/main_logo_light.avif"
              }
              alt={"Mail Logo"}
              className="max-w-[165px] h-[48px] "
              classes="hidden [.dark_&]:inline-block"
            />
          </Link>

          <SearchBarDesktop />

          {/* Desktop Menu */}
          <nav className="hidden xl:flex items-center gap-6">
            {menuItems.map((item) => {
              const href =
                item.key === "freeExam"
                  ? userInfo
                    ? "/student/free-exam"
                    : "/login"
                  : item.href;

              return (
                <Link
                  key={item.key}
                  href={href}
                  className="text-dark-blue-text hover:text-blue-light-text font-medium"
                >
                  {item.label}
                </Link>
              );
            })}
            {/* <a
              href="https://www.focusonlinebd.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-dark-blue-text hover:text-blue-light-text font-medium"
            >
              এডমিশন প্রোগ্রাম
            </a> */}
          </nav>

          {/* Right Side */}
          <div className="flex items-center gap-3">
            {/* <div className="light-dark-mode flex items-center hidden xl:block">
              <button className="cursor-pointer">
                <IoSunnyOutline className="text-2xl" />
              </button>
            </div> */}
            {/* Light/Dark Mode Toggle */}
            <div className="hidden xl:block">
              <ThemeToggle />
            </div>
            {/* Desktop Buttons */}
            <div className="hidden xl:block">
              <div className="flex items-center gap-4">
                {!userInfo && (
                  <>
                    <button className="call-now-btn">
                      {setting && (
                        <Link
                          href={`tel:${setting?.phone_1}`}
                          className="call-now"
                        >
                          <div>
                            <Image
                              src="/images/header-footer/call.avif"
                              alt="call Icon"
                              width={20}
                              height={20}
                              className="icon"
                              priority
                            />{" "}
                          </div>
                          কল করুন
                        </Link>
                      )}
                    </button>
                  </>
                )}

                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-4">
                    {userInfo ? (
                      <>
                        <div className="notification-wrap">
                          <StudentNotifications
                            isOpen={openMenu === "notification"}
                            toggleMenu={handleToggleNotification}
                          />
                        </div>
                        <div className="student-profile-wrap relative">
                          <StudentTopNav
                            isOpen={openMenu === "profile"}
                            toggleMenu={handleToggleProfile}
                            logoutHandler={() => {
                              Cookies.remove(F_TOKEN_STORE_KEY);
                              dispatch(setUser(null));
                              router.push("/login");
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <Link
                        href="/login"
                        className="login-reg-btn"
                        // onClick={() => dispatch(openDrawer("login"))}
                      >
                        <span className="login-btn">লগ ইন</span>/
                        <span className="reg-btn">রেজিস্টার</span>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Buttons */}
          <div className="xl:hidden flex items-center md:gap-4 gap-2.5 relative">
            <ThemeToggle />
            {setting && !userInfo && (
              <Link href={`tel:${setting?.phone_1}`} className="call-now">
                <div>
                  <Image
                    src="/images/header-footer/call.avif"
                    alt="call Icon"
                    width={20}
                    height={20}
                    className="icon"
                    priority
                  />{" "}
                </div>
              </Link>
            )}
            {/* Profile or login for mobile */}
            {userInfo ? (
              <>
                <div className="notification-wrap">
                  <StudentNotifications
                    isOpen={openMenu === "notification"}
                    toggleMenu={handleToggleNotification}
                  />
                </div>
                <div className="student-profile-wrap relative">
                  <StudentTopNav
                    isOpen={openMenu === "profile"}
                    toggleMenu={handleToggleProfile}
                    logoutHandler={() => {
                      Cookies.remove(F_TOKEN_STORE_KEY);
                      dispatch(setUser(null));
                      router.push("/login");
                    }}
                  />
                </div>
              </>
            ) : (
              <></>
              // <button
              //   className="login-reg-btn mobile"
              //   onClick={() => dispatch(openDrawer("login"))}
              // >
              //   <span className="login-btn">লগ ইন</span>
              //   <span className="reg-btn">/রেজিস্টার</span>
              // </button>
            )}

            <button
              onClick={toggleMenu}
              className="mobile-menu-icon"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <CloseOutlined style={{ fontSize: 20 }} />
              ) : (
                <MenuOutlined style={{ fontSize: 20 }} />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Profile Dropdown */}
      {isDropdownOpen && (
        <div className="xl:hidden absolute right-4 top-16 z-50 w-40 bg-fill-white rounded shadow-lg">
          <Link
            href="/student/dashboard"
            className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            ড্যাশবোর্ড
          </Link>
          <button
            onClick={()=>logoutHandler()}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          >
            লগ আউট
          </button>
        </div>
      )}

      <AuthMenuDrawer
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        userInfo={userInfo}
      />
      <AuthDrawer />
    </header>
  );
}
